import { render } from "./investors-panel--inactive.vue?vue&type=template&id=06270473&scoped=true&ts=true"
import script from "./investors-panel--inactive.vue?vue&type=script&lang=ts"
export * from "./investors-panel--inactive.vue?vue&type=script&lang=ts"

import "./investors-panel--inactive.vue?vue&type=style&index=0&id=06270473&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06270473"]])

export default __exports__